<template>
  <div class="scatter-area">
    <div class="stcontainer">
      <div class="bg">{{setBgText(1)}}</div>
      <div class="bg">{{setBgText(2)}}</div>
      <div class="bg">{{setBgText(3)}}</div>
      <div class="bg">{{setBgText(4)}}</div>
      <div class="pram -p1">{{setPramText(1)}}</div>
      <div class="pram -p2">{{setPramText(2)}}</div>
      <div class="pram -p3">{{setPramText(3)}}</div>
      <div class="pram -p4">{{setPramText(4)}}</div>

      <figure class="jobtype -estate"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_estate.svg" alt="不動産" class="jobicon"></div><figcaption>不動産</figcaption></figure>
      <figure class="jobtype -it"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_it.svg" alt="IT" class="jobicon"></div><figcaption>IT</figcaption></figure>
      <figure class="jobtype -shosha"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_syousya.svg" alt="商社" class="jobicon"></div><figcaption>商社</figcaption></figure>
      <figure class="jobtype -foodcompany"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_food.svg" alt="食品メーカー" class="jobicon"></div><figcaption>食品メーカー</figcaption></figure>
      <figure class="jobtype -bank"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_bank.svg" alt="銀行" class="jobicon"></div><figcaption>銀行</figcaption></figure>
      <figure class="jobtype -securities"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_money.svg" alt="証券" class="jobicon"></div><figcaption>証券</figcaption></figure>
      <figure class="jobtype -staffagancy"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_human.svg" alt="人材" class="jobicon"></div><figcaption>人材</figcaption></figure>
      <figure class="jobtype -cardealer"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_car.svg" alt="自動車ディーラー" class="jobicon"></div><figcaption>自動車<br class="_sp">ディーラー</figcaption></figure>
      <figure class="jobtype -mr"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_mr.svg" alt="製薬(MR)" class="jobicon"></div><figcaption>製薬(MR)</figcaption></figure>
      <figure class="jobtype -insurance"><div class="imgcover"><img src="../assets/img/cmnsvg/icon_hoken.svg" alt="保険" class="jobicon"></div><figcaption>保険</figcaption></figure>

    </div>
  </div><!-- .scatter-area -->
</template>

<script>
export default {
  props:["scaType"],
  computed:{
    setBgText(){
      return function(num){
        let bgtxt;
        if(this.scaType == "decision"){
          bgtxt ={
            1:"改善型",
            2:"投資型",
            3:"解決型",
            4:"冒険型"
          }
        }else{
          bgtxt ={
            1:"主張する",
            2:"引き出す",
            3:"教える",
            4:"受け止める"
          }
        }
        return bgtxt[num];
      }
    },
    setPramText(){
      return function(num){
        let pramtxt;
        if(this.scaType == "decision"){
          pramtxt ={
            1:"現実的",
            2:"規則的",
            3:"創造的",
            4:"柔軟的"
          }
        }else{
          pramtxt ={
            1:"好戦的",
            2:"大胆",
            3:"献身的",
            4:"慎重"
          }
        }
        return pramtxt[num];
      }
    }

  }  
}
</script>